// import moment from "moment"; //导入文件
const moment = require('moment')

// 自定义时间格式化的格式
// 如需要个性化请参考moment.js文档即可
const FOMART = 'YYYY-MM-DD'

function timeStandrd(time) {
  return time ? moment(time).format(FOMART) : '-'
}

module.exports = {
  timeStandrd
}
